import { render } from "./DetailTitle.vue?vue&type=template&id=35275c8a&scoped=true&ts=true"
import script from "./DetailTitle.vue?vue&type=script&lang=ts"
export * from "./DetailTitle.vue?vue&type=script&lang=ts"

import "./DetailTitle.vue?vue&type=style&index=0&id=35275c8a&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35275c8a"]])

export default __exports__